export default "__VITE_ASSET__BKT5vMzW__"